/**
 * 虚拟背景的能力检测与类型。
 *
 * 单独一个模块，是为了让 virtualBg.ts 保持「只在用户真开虚拟背景时才加载」——
 * 它静态引了 @mediapipe/tasks-vision（9.6MB wasm），一旦被别处静态 import，
 * 打包器就会把整包塞进主 chunk，所有人首次打开都要多下 9.6MB。
 */

export type BgMode = 'off' | 'blur' | 'image'

/** 本机是否具备跑虚拟背景的条件。 */
export function virtualBgSupported(): boolean {
  return (
    typeof MediaStreamTrackProcessor !== 'undefined' &&
    typeof OffscreenCanvas !== 'undefined' &&
    typeof WebAssembly !== 'undefined'
  )
}
